import api from "../../../core/api";
import { CategoryReference } from "../../inventory/models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.catalogApiBaseUrl };
}

class CustomerCategoriesApi {
  getCategories(): Promise<CategoryReference[]> {
    return api.get<CategoryReference[]>(`/v1/categories`, getRequestConfig())
      .then(x => x.data);
  }

  createCategory(name: string): Promise<CategoryReference> {
    return api.post<CategoryReference>(`/v1/categories`, { name }, getRequestConfig())
      .then(x => x.data);
  }
}

export default new CustomerCategoriesApi();